import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const ContentContext = createContext();

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data || {})).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  const get = (key, fallback) => {
    const v = content[key];
    return v === undefined || v === null ? fallback : v;
  };

  const save = async (key, value, type = "text", opts = {}) => {
    const prev = content[key];
    setContent((c) => ({ ...c, [key]: value }));
    try {
      await api.put(`/content/${key}`, { value, type });
      if (!opts.silent) {
        toast.success("Saved", {
          action: {
            label: "Undo",
            onClick: () => {
              setContent((c) => ({ ...c, [key]: prev }));
              if (prev === undefined || prev === null) {
                api.delete(`/content/${key}`).catch(() => {});
              } else {
                api.put(`/content/${key}`, { value: prev, type }).catch(() => {});
              }
            },
          },
        });
      }
    } catch (e) {
      setContent((c) => ({ ...c, [key]: prev }));
      toast.error("Could not save. Please try again.");
    }
  };

  return <ContentContext.Provider value={{ get, save, loaded }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
